import React, { ComponentProps, FunctionComponent } from "react";

const ChevronLeftIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 7 10",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M5.5 1.5L2 5L5.5 8.5",
      stroke: "currentColor",
      strokeWidth: 1.5,
    })
  );
};

const ForwardRef = React.forwardRef(ChevronLeftIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
